// Scroll Reveal — IntersectionObserver-based section reveal animation

export function initScrollReveal(): void {
    const reveals = document.querySelectorAll<HTMLElement>('.reveal');
    if (reveals.length === 0) return;

    // Skip animations if user prefers reduced motion
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        reveals.forEach(el => el.classList.add('reveal--visible'));
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            for (const entry of entries) {
                if (entry.isIntersecting) {
                    entry.target.classList.add('reveal--visible');
                    observer.unobserve(entry.target);
                }
            }
        },
        { threshold: 0.1 }
    );

    reveals.forEach(el => observer.observe(el));
}
